import React from 'react';

// Merchant experience page subcomponents could be loaded from core by default
// or from the org folder if custom template it required
import MerchantExperienceViewSingleCore from
  'core/modules/MerchantExperience/components/pageViews/MerchantExperienceViewSingle/MerchantExperienceViewSingle';

// import EarnContainer from '../../EarnContainer/EarnContainer';

function MerchantExperienceViewSingle(props) {
  return (
    <MerchantExperienceViewSingleCore {...props}>
      {/* According to https://tickets.cartera.com/browse/CLPL-2154
      the 'How to earn' component should be removed from the page
      but since the component was turned off via config and not removed entirely
      we keep a possibility to add it in a react version */}
      {/* <EarnContainer /> */}
    </MerchantExperienceViewSingleCore>
  );
}

export default MerchantExperienceViewSingle;
